import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      toAdd: {},
      deletedRows: [],
      isEdit: null,
      isAdding: false,
    };
  },
  props: {
    projectId: Number | String,
  },
  computed: {
    ...mapGetters("UNCoop", ["records", "loadingRecords", "working"]),
  },

  methods: {
    ...mapActions("UNCoop", [
      "addNewRecord",
      "updateRecord",
      "fetchRecords",
      "deleteRecord",
    ]),
    onEditClicked(row) {
      this.isAdding = false;
      this.isEdit = row.id;
      this.toAdd = { ...row };
    },
    onNewClicked() {
      this.isEdit = null;
      this.isAdding = true;
      this.toAdd = {};
    },
    async onSaveClicked(endpoint) {
      if (this.isAdding) {
        await this.addNewRecord({
          endpoint,
          form: {
            ...this.toAdd,
            project_id: this.projectId,
          },
        });
        this.isAdding = false;
      } else {
        await this.updateRecord({
          endpoint: endpoint + "/" + this.toAdd.id,
          form: {
            ...this.toAdd,
            project_id: this.projectId,
          },
        });
        this.isEdit = null;
      }
      this.refreshData();
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف السجل", {
          title: "تأكيد الحذف",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteRecord(this.operationsEndpoint + "/" + id);
            await this.refreshData();
          }
        });
    },
    async refreshData() {
      await this.fetchRecords(this.fetchEndpoint);
    },
    async onSubmit(index) {
      if (this.isAdding) {
        await this.$refs.FormValidation.validate().then(async (success) => {
          if (success) {
            this.onSaveClicked(this.operationsEndpoint);
          }
        });
      } else if (this.isEdit !== null) {
        await this.$refs.EditFormValidation[0]
          .validate()
          .then(async (success) => {
            if (success) {
              this.onSaveClicked(this.operationsEndpoint);
            }
          });
      }
    },
  },
  async created() {
    if (!this.fetchEndpoint.includes("activities")) await this.refreshData();
  },
};
